import { LoadingSpinner } from '@/components/common/LoadingSpinner'
import styles from './PageLoader.module.css'

export function PageLoader() {
  return (
    <div className={styles.container}>
      <LoadingSpinner size="lg" />
    </div>
  )
}
